const breakPoint = 767;
let resizeFlag   = false;
let windowWidth  = window.innerWidth;
let windowHeight = window.innerHeight;
let windowWidthJ = $(window).width();



const videoControl = (action, target) => {
  var $playerWindow = $(target)[0].contentWindow;
  $playerWindow.postMessage('{"event":"command","func":"' + action + '","args":""}', '*');
}

// ------------------------------------------------------------------------
// autoPlay
// ----- BOTH
// ------------------------------------------------------------------------
const autoPlay = () => {
  $(window).on("load", function () {
    if ($(".autoplay").length !== 0) {
      videoControl("playVideo", ".autoplay");
    }
  });
};

// ------------------------------------------------------------------------
// preload
// ----- BOTH
// ------------------------------------------------------------------------
const preload = () => {
  $(window).on("load", function () {
    $("body").removeClass("preload");
    $("body").css("opacity", "");
  });
};

// ------------------------------------------------------------------------
// anchorLink
// ----- BOTH
// ------------------------------------------------------------------------
const anchorLink = () => {
  $("a[href^='#']").on("click", function(){
    var linkSpeed    = 800;
    var linkHref     = $(this).attr("href");
    var linkTarget   = $(linkHref == "#" || linkHref == "" ? 'html' : linkHref);
    var linkAdjust   = 0;
    var linkPosition = linkTarget.offset().top;
    $("html, body").animate({scrollTop: linkPosition - linkAdjust}, linkSpeed, "swing");
    return false;
  });
};


// ------------------------------------------------------------------------
// charaSlider
// ----- BOTH
// ------------------------------------------------------------------------
const charaSlider = () => {
  let effect;
  let fade;
  let plus;
  if (matchMedia('(min-width: 768px)').matches) {
    effect = "fade";
    fade = true;
    plus = 1;
  } else {
    effect = "slide";
    fade = false;
    plus = 0;
  }
  let puSlider = new Swiper('.chara-track', {
    speed: 600,
    loop: true,
    slidesPerView: "auto",
    centeredSlides: true,
    preventLinks: false,
    simulateTouch: false,
    effect: effect,
    fadeEffect: {
      crossFade: fade
    },
    navigation: {
      nextEl: ".chara-nav_next",
      prevEl: ".chara-nav_prev",
    },
    pagination: {
      el: '.chara-dot',
      type: 'bullets',
      clickable: true,
      renderBullet: function (index, className) {
        let targetImage = this.slides[index + plus].dataset.icon;
        return '<div class="' + className + '"><div class="swiper-pagination-bullet-icon" style="background:url(./assets/images/common/' + targetImage + ') no-repeat;background-size:cover;background-position:center;">' + '</div></div>';
      },
    },
  });
};

// ------------------------------------------------------------------------
// movieModal
// ------------------------------------------------------------------------
const movieModal = () => {
  const ua = navigator.userAgent;
  $("[data-youtube]").on("click", function () {
    let youtubeId = $(this).data("youtube");
    let embedUrl = "https://www.youtube.com/embed/" + youtubeId + "?autoplay=1&enablejsapi=1";
    $('.modal-wrapper').append('<iframe id="modal-youtube" width="560" height="315" src="" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen=""></iframe>');
    $(".sw-Modal").addClass("open");
    if ($(".autoplay").length !== 0) {
      videoControl("pauseVideo", '.autoplay');
    }
    $('#modal-youtube').attr("src", embedUrl);
    $('#modal-youtube').on('load', function () {
      if (/android/i.test(ua) || matchMedia('(min-width: 768px)').matches) {
        videoControl("playVideo", '#modal-youtube');
        videoControl("unMute", '#modal-youtube');
      }
    });
    $('.modal-close , .sw-Modal').on('click', function () {
      $(".sw-Modal").removeClass("open");
      setTimeout(function () {
        $('.modal-wrapper iframe').remove();
        if ($(".autoplay").length !== 0) {
          videoControl("playVideo", '.autoplay');
        }
      }, 400);
    });
  });
};



// ------------------------------------------------------------------------
// imageModal
// ----- BOTH
// ------------------------------------------------------------------------
const imageModal = () => {
  $('.cg-toggle').on('click', function () {
    let targetSrc = $(this).data('image');
    $('.sw-Modal').toggleClass('open');
    $('.modal-wrapper').append('<img src="' + targetSrc + '">');
    if (navigator.userAgent.indexOf('iPhone') > 0 || navigator.userAgent.indexOf('Android') > 0 && navigator.userAgent.indexOf('Mobile') > 0 || navigator.userAgent.indexOf('iPad') > 0 || navigator.userAgent.indexOf('Android') > 0) {
      $("meta[name=viewport]").attr('content', 'width=device-width, initial-scale=1,minimum-scale=1, maximum-scale=2, user-scalable=yes');
    }
  });
  $('.sw-Modal_Close , .sw-Modal').on('click', function () {
    $(".sw-Modal").removeClass("open");
    setTimeout(function () {
      $('.modal-wrapper img').remove();
    }, 400);
    if (navigator.userAgent.indexOf('iPhone') > 0 || navigator.userAgent.indexOf('Android') > 0 && navigator.userAgent.indexOf('Mobile') > 0 || navigator.userAgent.indexOf('iPad') > 0 || navigator.userAgent.indexOf('Android') > 0) {
      $("meta[name=viewport]").attr('content', 'width=device-width, initial-scale=1,minimum-scale=1, maximum-scale=1, user-scalable=yes');
    }
  });
};


// ------------------------------------------------------------------------
// toggleMenu
// ------------------------------------------------------------------------
const toggleMenu = () => {
  $(".hamburger-button,.header-nav_item a").on("click", function () {
    $(".st-Header_Inner").toggleClass("open");
    $(".hamburger-button").toggleClass("open");
  });
};


// ------------------------------------------------------------------------
// scrollAnime
// ------------------------------------------------------------------------
const scrollAnime = () => {
  let margin = 0;
  if (matchMedia('(max-width: 768px)').matches) {
    margin = 200;
  } else {
    margin = 500;
  }
  $(".js-sc").each(function (i, node) {
    gsap.to(node, {
      scrollTrigger: {
        trigger: node,
        start: 'top bottom-=' + margin,
        toggleClass: { targets: node, className: "animated" },
        once: true,
      }
    });
  });
};


// ------------------------------------------------------------------------
// loadAnime
// ------------------------------------------------------------------------
const loadAnime = () => {
  $(window).on("load", function () {
    $(".js-ld").toggleClass("animated");
  });
};


export {
  preload,
  autoPlay,
  anchorLink,
  charaSlider,
  movieModal,
  imageModal,
  toggleMenu,
  scrollAnime,
  loadAnime
}



// WEBPACK FOOTER //
// ./src/assets/js/include/module.js